import { version } from 'react';
import ReactDOM from 'react-dom';

import moment from 'moment';
import momentRuLocale from 'moment/locale/ru';
import { ErrorBoundary } from 'react-error-boundary';
import numeral from 'numeral';
import 'numeral/locales/ru';
import 'react-toastify/dist/ReactToastify.css';

import { toast, ToastContainer } from 'react-toastify';
import { onReady } from '@yooink/youtils/es/onReadyPage';
import App from './App';
import { UserHOC } from './Engine/Auth/UserContext';
import { subscribe } from './Utils/Notifications';

const rootEl = document.getElementById('root');

moment.updateLocale('ru', momentRuLocale);
moment.locale('ru');

numeral.locale('ru');

window.APP_INFO = {
	VERSION: process.env.APP_VERSION,
	GIT_COMMIT: process.env.GIT_COMMIT,
	GIT_SHORT_COMMIT: process.env.GIT_SHORT_COMMIT,
	GIT_BRANCH: process.env.GIT_BRANCH,
	GIT_COMMIT_DATE: process.env.GIT_COMMIT_DATE,
	BUILD_MACHINE_HOSTNAME: process.env.BUILD_MACHINE_HOSTNAME,
	BUILD_OS: process.env.BUILD_OS,
	BUILD_DATE: process.env.BUILD_DATE,
	GITLAB_USER_LOGIN: process.env.GITLAB_USER_LOGIN,
	REACT_RUNTIME_VERSION: version
};

// eslint-disable-next-line react/prop-types
const MyFallbackComponent = ({ componentStack, error }) => (
	<div>
		<p><strong>Хьюстон, у нас проблема!</strong></p>
		<p>Вот что мы знаем:</p>
		<p><strong>Ошибка:</strong> {error.toString()}</p>
		<p><strong>Cтектрейс:</strong> <pre>{componentStack}</pre></p>
		<pre>{JSON.stringify(window.APP_INFO, null, 4)}</pre>
	</div>
);

const render = (NextApp) => ReactDOM.render(
	<UserHOC>
		<ErrorBoundary FallbackComponent={MyFallbackComponent}>
			{NextApp ? <NextApp /> : <App />}
		</ErrorBoundary>
		<ToastContainer theme="colored" />
	</UserHOC>,
	rootEl
);

render();

onReady(async () => {
	try {
		const registration = await navigator.serviceWorker.register('/sw.js');
		console.log('Service worker successfully registered.');
		if (globalThis.Notification.permission === 'granted' && window.IS_LOGIN) {
			const subscription = await registration.pushManager.getSubscription();
			if (!subscription) {
				return subscribe(registration);
			}
		}
	} catch (e) {
		console.error(e);
	}
});

if (module.hot) {
	module.hot.accept('./App', () => {
		// eslint-disable-next-line global-require
		const NextApp = require('./App').default;
		render(NextApp);
	});
}
// Уведомления о статусе сборки проекта (dev only)
if (process.env.NODE_ENV === 'development') {
	const whmEvents = window.__whmEventSourceWrapper['/__webpack_hmr'];

	whmEvents.addMessageListener((event) => {
		if (event.data == '\uD83D\uDC93') {
			return;
		}
		try {
			processMessage(JSON.parse(event.data));
		} catch (ex) {
			if (options.warn) {
				console.warn(`Invalid HMR message: ${event.data}\n${ex}`);
			}
		}
	});
	let toastId = null;
	function processMessage (obj) {
		switch (obj.action) {
			case 'building': {
				if (toastId === null) {
					toastId = toast('Recompile', {
						type: toast.TYPE.INFO,
						autoClose: false
					});
				} else {
					toast.update(toastId, {
						type: toast.TYPE.INFO,
						render: 'Recompile',
						autoClose: false
					});
				}
				break;
			}
			case 'built': {
				if (obj.errors.length) {
					if (toastId === null) {
						toastId = toast(`Build error!`, {
							type: toast.TYPE.ERROR,
							autoClose: 2500
						});
					} else {
						toast.update(toastId, {
							type: toast.TYPE.ERROR,
							render: `Build error!`,
							autoClose: 2500
						});
						toastId = null;
					}
					return;
				}
				if (toastId === null) {
					toastId = toast(`bundle rebuilt in ${obj.time}ms`, {
						type: toast.TYPE.SUCCESS,
						autoClose: 2500
					});
				} else {
					toast.update(toastId, {
						type: toast.TYPE.SUCCESS,
						render: `bundle rebuilt in ${obj.time}ms`,
						autoClose: 2500
					});
					toastId = null;
				}
				break;
			}
			case 'sync': {
				break;
			}
		}
	}
}
